var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiya(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_8348_52507)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M48 96C21.12 96 13.8831 94.6412 7.62092 88.3791C1.32923 82.0726 0 74.88 0 48C0 21.12 1.35877 13.9274 7.62092 7.62092C13.8831 1.35877 21.12 0 48 0C74.88 0 82.1169 1.35877 88.3791 7.62092C94.6708 13.9274 96 21.12 96 48C96 74.88 94.6708 82.0726 88.3791 88.3791C82.1169 94.6412 74.88 96 48 96Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M66.8308 47.9546C64.9994 47.9546 63.8031 46.7435 63.8031 44.9564C63.8031 43.1989 65.0142 42.0026 66.8308 42.0026H71.616V47.9546H66.8308ZM75.6185 38.5466H66.3582C62.4296 38.5466 59.7416 41.1164 59.7416 44.8087C59.7416 47.733 61.4105 49.9484 64.0542 50.7164L59.0031 58.4112H63.4782L68.0271 51.4106H71.6013V58.4112H75.6185V38.5466ZM25.5213 43.7601V37.7638H33.3047V54.7632H23.5422C24.5908 52.9318 25.5213 48.693 25.5213 43.7601ZM37.4253 33.9238H21.5484V43.9226C21.5484 49.018 20.6474 52.9909 19.4511 54.778H17.5459V63.8463H21.4745V58.485H36.3324V63.8463H40.261V54.778H37.4253V33.9238ZM49.4031 55.0438L49.0487 54.8075L53.6862 38.5466H44.3077L43.3034 42.165L48.7533 42.1207L45.2087 54.5269C44.5884 56.7866 46.1096 58.8838 48.5908 58.8838C49.3736 58.8838 50.1416 58.6918 50.9982 58.1454L57.3785 53.8327L55.429 50.9527L49.4031 55.0438ZM52.1207 34.81C54.0997 34.81 54.9268 34.0715 54.9268 32.314C54.9268 30.4826 54.0702 29.7441 52.1207 29.7441C50.1711 29.7441 49.3145 30.4826 49.3145 32.314C49.3293 34.0715 50.1416 34.81 52.1207 34.81Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8348_52507"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiya);
export default __webpack_public_path__ + "static/media/diya.68ec6b515f3f87f8287cc9b5e73dc291.svg";
export { ForwardRef as ReactComponent };